import React from 'react'
import './Footer.css'
import Github from '../../assets/github.png'
import Instagram from '../../assets/instagram.png'
import LinkedIn from '../../assets/linkedin.png'
import Logo from '../../assets/logo.png'

const Footer = () => {
    return (
        <div className='footer-container'>
            <hr />
            <div className="footer">
                <div className="social-link">
                    <img src={Github} alt="github-img" />
                    <img src={Instagram} alt="insta-img" />
                    <img src={LinkedIn} alt="linkedin-img" />
                </div>
                <div className="logo-f">
                    <img src={Logo} alt="fit-logo" />
                </div>
            </div>
            <div className="blur footer-blur-1"></div>
            <div className="blur footer-blur-2"></div>
        </div>
    )
}

export default Footer
